module.exports = __webpack_public_path__ + "static/media/stars.50ee9232.svg";